var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBell = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 24,
  viewBox: "0 0 22 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.2,3.3a1.884,1.884,0,0,1-.2-.8,2,2,0,0,1,4,0,2.354,2.354,0,0,1-.2.8",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.32
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,19.5H1.5v-2h0a7.3,7.3,0,0,0,4.3-6.655V9.2A6.2,6.2,0,0,1,12,3h0a6.2,6.2,0,0,1,6.2,6.2v1.645A7.3,7.3,0,0,0,22.5,17.5h0v2Z",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.32
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5,19.5V20a3.5,3.5,0,1,1-7,0v-.5",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 1.32
}))));
export default SvgIconBell;